/*
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL SARL
 */
import React, { Component } from 'react';
import { Popup, Card, Icon, Button, Checkbox } from '@scuf/common';
import { filter, includes, groupBy } from 'lodash';
import './FilterPopup-theme.scss';
import { SKUColumnList } from '../../modules/onboarding/PartnerManagement/SKULIst/SKUConfig';
import i18next from 'i18next';
interface IFilterPopupState {
  isPopOpen: boolean;
  reDraw: boolean;
}
export interface IColumn {
  id: number;
  name: string;
  fieldName: string;
  propertyName?: string;
  show?: boolean;
  sortable?: boolean;
  precision?: string;
  symbol?: string;
  columnWidth?: string;
  removable: boolean;
  type?: string;
  priority?: number;
  expectedValue?: any;
  group?: string;
  dataType?: string;
  sortField?: string;
  image?: any;
  renderer?: (cellData: ITreeNode) => JSX.Element;
}
export interface ITreeNode {
  key: string;
  children: ITreeNode[];
  data: any;
}
export interface IFilterPopupConfig {
  columns: Array<IColumn>;
  desktopDefaultColumns: Array<string>;
  tabletDefaultColumns: Array<string>;
  mobileDefaultColumns: Array<string>;
}

interface IFilterPopupProps {
  tableColumnData: IFilterPopupConfig;
  screenSize: number;
  allowedColumnCount: Array<number>;
  defaultColumnIncluded: boolean;
  icon?: string;
  isFilterActive?: boolean;
  headerText?: string;
  excludeMetaData?: boolean;
  onFilter?: (data: Array<IColumn>) => void;
  onFilterClick?: (data: Array<IColumn>) => void;
}

export class FilterPopup extends Component<
  IFilterPopupProps,
  IFilterPopupState
> {
  selectedColumns: Array<string>;
  allRemovableColumnCount: number;
  constructor(props: IFilterPopupProps) {
    super(props);
    this.selectedColumns = SKUColumnList.desktopDefaultColumns;
    this.allRemovableColumnCount = 0;
    this.state = {
      isPopOpen: false,
      reDraw: false
    };
  }
  getDefaultSelectedColumns(screenSize: number) {
    return this.selectedColumns = Object.assign(
      [],
      SKUColumnList.desktopDefaultColumns
    );
  }

  apply() {
    const filteredColumns = this.props.tableColumnData.columns.filter(x =>
      includes(this.selectedColumns, x.fieldName)
    );
    if (this.props.onFilter) {
      this.props.onFilter(filteredColumns);
    }
    this.hidePopup();
  }
  applyOnClick() {
    const filteredColumns = this.props.tableColumnData.columns.filter(x =>
      includes(this.selectedColumns, x.fieldName)
    );
    if (this.props.onFilterClick) {
      this.props.onFilterClick(filteredColumns);
    } else if (this.props.onFilter) {
      this.props.onFilter(filteredColumns);
    }
    this.hidePopup();
  }
  isChecked(column: IColumn) {
    return includes(this.selectedColumns, column.fieldName);
  }

  columnChecked(fieldName: string) {
    const index = this.selectedColumns.indexOf(fieldName);
    if (index === -1) {
      this.selectedColumns.push(fieldName);
    } else {
      this.selectedColumns.splice(index, 1);
    }
    this.setState({
      reDraw: !this.state.reDraw
    });
  }

  hidePopup() {
    this.setState({
      isPopOpen: false
    });
  }

  handleOpen() {
    this.setState({
      isPopOpen: true
    });
  }

  componentDidMount() {
    // this.getDefaultSelectedColumns(this.props.screenSize);
    this.allRemovableColumnCount = filter(
      this.props.tableColumnData.columns,
      x => x.group !== 'Default' && x.removable !== false
    ).length;
  }

  computeGrouping = (columnResize: boolean) => {
    let columns = filter(this.props.tableColumnData.columns, ['show', true]);
    let groupColumns = groupBy(columns, 'group');
    let columnContent;
    let structure = [];
    let count = 100;
    for (let group in groupColumns) {
      if (group !== 'Default' && groupColumns[group].length > 0) {
        structure.push(
          <div key={count++}>
            <span className="filter-header">{i18next.t(group)}</span>
            {groupColumns[group].map(x => {
              if (x.image) {
                return (
                  <div className="filter-with-image" key={x.id}>
                    <Checkbox
                      id={x.fieldName}
                      key={x.id}
                      defaultChecked={this.isChecked(x)}
                      onClick={() => this.columnChecked(x.fieldName)}
                    />
                    <img src={x.image} alt={x.name} />
                    <label htmlFor={x.fieldName}>
                      {i18next.t(x.name) + ' ' + (x.symbol ? x.symbol : '')}
                    </label>
                  </div>
                );
              }
              return (
                x.removable && (
                  <Checkbox
                    label={i18next.t(x.name) + ' ' + (x.symbol ? x.symbol : '')}
                    key={x.id}
                    defaultChecked={this.isChecked(x)}
                    onClick={() => this.columnChecked(x.fieldName)}
                  />
                )
              );
            })}
          </div>
        );
      }
    }

    columnContent = (
      <div
        className={
          'stat-column-content ' + (columnResize ? 'column-size-reached' : '')
        }
      >
        {structure}
      </div>
    );

    return columnContent;
  };
  getAllowedCountAndResizeState(screenSize: number) {
    let allowedCount = this.props.allowedColumnCount[0];
    allowedCount =
      this.allRemovableColumnCount < allowedCount
        ? this.allRemovableColumnCount
        : allowedCount;
    const columnResize = this.selectedColumns.length >= allowedCount;
    return { allowedCount, columnResize };
  }

  shouldComponentUpdate(nextProps: IFilterPopupProps) {
    // TODO Selected based on screen size is not a good option. It makes multiple api calls when screen size changed.
    if (this.props.screenSize !== nextProps.screenSize) {
      // this.getDefaultSelectedColumns(nextProps.screenSize);
      this.apply();
      return false;
    }
    return true;
  }

  render() {
    const { screenSize, headerText, excludeMetaData } = this.props;
    const { allowedCount, columnResize } = this.getAllowedCountAndResizeState(
      screenSize
    );
    const titleText = headerText ? headerText : i18next.t('columnSelection');
    return (
      <Popup
        className="stat-column-popup alarm-filter-popup"
        element={
          <Icon
            root="common"
            name={this.props.icon ? this.props.icon : 'filter1'}
            description={titleText}
            className={this.props.isFilterActive ? 'filter-active' : ''}
            size="small"
          />
        }
        position="bottom right"
        on="click"
        open={this.state.isPopOpen}
        onOpen={() => this.handleOpen()}
        onClose={() => this.hidePopup()}
      >
        <Card>
          <Card.Header title={titleText} className="popup-header">
            <Icon
              root="global"
              className="close-icon"
              name="close"
              size="small"
              onClick={() => this.hidePopup()}
            />
          </Card.Header>
          {excludeMetaData === true ? null : (
            <Card.Meta className="stat-column-desc">
              {i18next.t('selectUpTo')}{' '}
              {this.props.defaultColumnIncluded
                ? allowedCount - 1
                : allowedCount}{' '}
              {i18next.t('itemsToDisplay')}
            </Card.Meta>
          )}
          <Card.Content>
            <div className="column-filter-container">
              {this.computeGrouping(columnResize)}
              <div className="apply-change-stat-column">
                <Button
                  type="inline"
                  size="small"
                  onClick={() => this.applyOnClick()}
                  content={i18next.t('apply')}
                />
              </div>
            </div>
          </Card.Content>
        </Card>
      </Popup>
    );
  }
}

export default FilterPopup;
